module.exports = __webpack_public_path__ + "media/images/icons/file-49561ed5d382329d2d7f14aac929618d.svg";